(() => {
  // Cookie management functions
  const setCookie = (name, value, days = 365) => {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/;SameSite=Lax`;
  };

  const getCookie = (name) => {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  };

  // Generate random alphanumeric string
  const generateRandomString = (length = 16) => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  };

  // Initialize anonymous user token
  const initializeAnonymousUser = () => {
    const cookieName = 'algolia_anonymous_user_token';
    let userToken = getCookie(cookieName);
    
    if (!userToken) {
      userToken = `anonymous-user-${generateRandomString()}`;
      setCookie(cookieName, userToken);
    }

    // Set the user token for Algolia if aa is available
    if (window.aa) {
      window.aa('setUserToken', userToken);
    } else {
      // If aa is not available yet, wait for it
      const checkAA = setInterval(() => {
        if (window.aa) {
          window.aa('setUserToken', userToken);
          clearInterval(checkAA);
        }
      }, 100);

      // Clear interval after 10 seconds if aa is still not available
      setTimeout(() => clearInterval(checkAA), 10000);
    }
  };

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAnonymousUser);
  } else {
    initializeAnonymousUser();
  }
})(); 